"use client";

/**
 * Backward-compat re-export. Components that imported
 *   `import { Link } from "@/components/LocaleLink"`
 * keep working unchanged — they now get the next-intl/navigation Link,
 * which handles locale prepending natively (better than the old custom
 * implementation that fought with the URL).
 *
 * New code should `import { Link } from "@/i18n/navigation"` directly.
 * Phase 6 of the i18n overhaul will codemod the imports + delete this file.
 */
export { Link } from "@/i18n/navigation";
